















































import Vue from 'vue';
import Component from 'vue-class-component';
import { VAutocomplete, VTextField } from 'vuetify/lib';
import { Action, State } from 'vuex-class';
import { client } from '../../store';
import { Watch, Prop } from 'vue-property-decorator';
@Component({
  components: { VAutocomplete, VTextField },
})
export default class ProposalFilterItem extends Vue {
  @Prop({ required: true }) readonly searchKey: string;
  @Prop({ required: true }) readonly component: string;
  @Prop({ required: true }) readonly label: string;
  @Prop({ required: false }) readonly url: string;
  @Prop({ required: false }) readonly multiple: string;
  @Prop({ required: true }) readonly itemText: string;
  @Prop({ required: false }) readonly immediately: boolean;
  @Action('getEntities', { namespace: 'proposal' }) getEntities: () => void;
  @State('params', { namespace: 'tableFilters' }) params: object;
  @Action('setParam', { namespace: 'tableFilters' }) setParam: (
    payload: object,
  ) => void;
  @Action('toggleCompare', { namespace: 'tableFilters' }) toggleCompare: (
    payload: object,
  ) => void;

  items = [];

  get moduleParams() {
    // @ts-ignore
    return this.params.proposal || {};
  }
  get unpreparedValues() {
    // @ts-ignore
    return this.moduleParams[this.searchKey]
      ? this.moduleParams[this.searchKey]
      : [];
  }
  get value() {
    if (!this.multiple) {
      return this.unpreparedValues;
    }
    // @ts-ignore
    return Array.isArray(this.moduleParams[this.searchKey])
      ? // @ts-ignore
        // @ts-ignore
        this.moduleParams[this.searchKey].map((item: number | string) =>
          Number(item.toString().replace(/!/, '')),
        )
      : [];
  }
  set value(value) {
    this.setParam({
      module: 'proposal',
      key: this.searchKey,
      value,
      // @ts-ignore
    }).then(() => this.getEntities());
  }
  searchString = '';
  async mounted() {
    if (this.immediately) {
      await client.get(this.url).then(({ data }) => {
        this.items = data;
        // @ts-ignore
        const itemsIds = this.items.flatMap(({ id }) => id);
        this.value.map((id: number, index:number) => {
          // @ts-ignore
          if (!itemsIds.includes(id)) {
            this.remove(index);
          }
        });
      });
    }
  }
  toggle(index: number) {
    this.toggleCompare({
      module: 'proposal',
      key: this.searchKey,
      index,
      // @ts-ignore
    }).then(() => this.getEntities());
  }
  remove(idx: number) {
    this.value = this.value.filter(
      (item: number | string, index: number) => index !== idx,
    );
  }
  @Watch('searchString')
  getItems() {
    if (this.searchString !== null && !this.immediately) {
      client
        .get(this.url, { params: { search: this.searchString } })
        .then(({ data }) => {
          this.items = data;
        });
    }
  }
}
